module.exports = __webpack_public_path__ + "static/media/view-block.1819717a.svg";